import { useNavigate } from 'react-router-dom'
import useAuthStore from '../../store/authStore.js'
import { useLanguage } from '../../i18n/index.jsx'

/**
 * Shown at the top of every AppLayout page when a platform admin
 * has used "Log in as" to enter a company's account.
 * Active state is tracked in authStore (in-memory, not sessionStorage).
 */
export default function ImpersonationBanner() {
  const { tenant, exitImpersonation, isImpersonating } = useAuthStore()
  const navigate = useNavigate()
  const { t } = useLanguage()

  if (!isImpersonating) return null

  const handleExit = () => {
    exitImpersonation()
    navigate('/super-admin')
  }

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 'var(--z-overlay)',
      background: 'linear-gradient(90deg, #f59e0b, #d97706)',
      color: 'var(--text-primary)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '8px 20px',
      fontSize: 'var(--text-caption)', fontWeight: 500,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 'var(--text-lg)' }}>⚠️</span>
        <span>
          {t('impersonationWarning').replace('{{name}}', tenant?.name || t('aCompanyAccount'))}
        </span>
      </div>
      <button
        onClick={handleExit}
        style={{
          background: 'rgba(0,0,0,0.15)', border: '1px solid rgba(0,0,0,0.2)',
          borderRadius: 6, padding: '4px 14px', fontSize: 'var(--text-sm)', fontWeight: 700,
          cursor: 'pointer', color: 'var(--text-primary)', whiteSpace: 'nowrap',
        }}
      >
        ✕ {t('exitImpersonation')}
      </button>
    </div>
  )
}
